// extracted by mini-css-extract-plugin
export default {"main":"forget_main__EM1Kv","container":"forget_container__XIE9e","subContainer":"forget_subContainer__aWySI","card":"forget_card__5GymO","closeIcon":"forget_closeIcon__D3+fu"};